<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container" *ngIf="mode == 'login'">
            <div class="row">
                <div class="col-md-8 mx-auto">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <form [formGroup]="loginForm" (ngSubmit)="onLogon()">
                                    <h1><img src="assets/img/brand/sprout.png" style="width: 40px;"/> Sprout<span class="sprout-scribe">Scribe</span></h1>
                                    <h4 class="text-muted">Sign in to your account</h4>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="email" formControlName="emailAddress" class="form-control" placeholder="Enter your email address (username)" autocomplete="username" required>
                                    </div>
                                    <div class="input-group mb-4">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-lock"></i></span>
                                        </div>
                                        <input type="password" formControlName="password" class="form-control" placeholder="Password" autocomplete="current-password" required>
<!--                                        <p class="help-block">First Name</p>-->
<!--                                        <div class="form-control-feedback" style="min-width: 300px;">short</div>-->
                                        <div id="passwordHelpBlock" class="form-text text-danger" style="min-width: 300px;" *ngIf="errorMessage">
                                            {{errorMessage}}
                                        </div>
<!--                                        <div *ngIf="!errorMessage">-->
<!--                                            <small class="text-danger" >-->
<!--                                                {{errorMessage}}testing...-->
<!--                                            </small>-->
<!--                                        </div>-->
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <button type="submit" (click)="onLogon()" [disabled]="loginForm.invalid || submitting" style="background-color: #4f9b35;" class="btn btn-success px-4">
                                                {{loginButtonText}}</button>
                                        </div>
<!--                                        <div class="col-6 text-right">-->
<!--                                            <button (click)="onForgotPassword()" type="button" class="btn btn-link px-0 sprout-green-link">Forgot password?</button>-->
<!--                                        </div>-->
                                    </div>
<!--                                    <div class="row" *ngIf="errorMessage">-->
<!--                                        <div class="text-danger" >-->
<!--                                            {{errorMessage}}-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </form>
                            </div>
                        </div>
<!--                        <div class="card text-white py-5 d-md-down-none sprout-green-bg" style="width:44%">-->
<!--                            <div class="card-body text-center">-->
<!--                                <div>-->
<!--                                    <h2>Sign up</h2>-->
<!--                                    <p>Sign up for a Sprout<span style="font-style: italic;">Scribe</span> account to create new forms and templates.</p>-->
<!--                                    <div class="sign-up-btn-block">-->
<!--                                        <button type="button" (click)="onSignUp()" class="btn btn-ghost-dark active mt-3 sprout-green-btn">Sign up Now!</button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
